import FileSaver from 'file-saver'
import mime from 'mime/lite'

/**
 * File utilities
 *
 * @type {ngService}
 */
export class TmrFile {
  static ngType = 'service'

  /**
   * Download a file from an http request
   *
   * @example
   * TmrFile.download(TmrApi.get('someEndpoint'), 'defaultFilename.txt')
   *
   * @param {Promise} request An http request, usually performed by TmrApi
   * @param {string} fileName The default file name.
   * @param {string} type The mime type. If not provided, tries to deduce it from the fileName extension
   * @param {boolean} download If false, just return the loaded file, dont' pass it to the browser for download
   */
  download(
    request,
    fileName,
    type = mime.getType(fileName.split('.')[1]) ?? 'text/plain',
    download = true
  ) {
    return request.then(res => {
      let contentDisposition = res.headers('content-disposition')
      fileName = contentDisposition
        ? contentDisposition.match(/filename="(.*)"/)[1]
        : fileName
      let file = new File([res.data], fileName, { type })
      if (download) FileSaver.saveAs(file)
      return file
    })
  }
}
